import { downloadBlob } from 'cng-common/helpers/io'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import settings from 'src/config/settings'

export const downloadReports = async (entryIds: number[], archiveName: string) => {
  const serviceUrl = settings.httpsServices.partner360
    ? settings.httpsServices.partner360
    : 'https://partner360-service-itg.corp.hpicloud.net'

  const url = `${serviceUrl}/api/v0/exportDocument/downloadReports`

  const [token] = getTokens()
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      entryIds,
      archiveName,
    }),
  })

  if (response.ok) {
    const blob = await response.blob()
    downloadBlob(`${archiveName}.zip`, blob)

    return true
  }

  return false
}
